import { render } from "./WCCartDrawerOrderCard.vue?vue&type=template&id=223b3199&scoped=true"
import script from "./WCCartDrawerOrderCard.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerOrderCard.vue?vue&type=script&lang=js"

import "./WCCartDrawerOrderCard.vue?vue&type=style&index=0&id=223b3199&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223b3199"]])

export default __exports__